export { default } from './BancoAutoMoto';
